import { render } from "./PortfolioPage.vue?vue&type=template&id=0de09932"
import script from "./PortfolioPage.vue?vue&type=script&lang=js"
export * from "./PortfolioPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__